import { render, staticRenderFns } from "./BetaProgramApplication.vue?vue&type=template&id=189301e0&scoped=true&"
import script from "./BetaProgramApplication.vue?vue&type=script&lang=js&"
export * from "./BetaProgramApplication.vue?vue&type=script&lang=js&"
import style0 from "./BetaProgramApplication.vue?vue&type=style&index=0&id=189301e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189301e0",
  null
  
)

export default component.exports